import React from 'react'
import { Checkbox, CheckboxProps } from 'semantic-ui-react'

import { PermissionGroup } from './PermissionGroup'
import { OnCheck } from './AllPermissions'

interface CertificatePermissionsProps {
  onChange: (data: OnCheck) => void
  isChecked: (resource: string, actions: string[]) => boolean
}

export const CertificatePermissions: React.FC<CertificatePermissionsProps> = ({
  onChange,
  isChecked
}) => {
  function handleCheck(
    event: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps
  ) {
    const value = data.value as string
    const checked = data.checked as boolean
    onChange({ value, checked })
  }

  return (
    <PermissionGroup label="Certificado:">
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('certificate', ['Get', 'List'])}
        value="certificate:Get,List"
        label="Ler"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('certificate', ['Create'])}
        value="certificate:Create"
        label="Cadastrar"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('certificate', ['Update'])}
        value="certificate:Update"
        label="Atualizar"
      />
      <Checkbox
        onChange={handleCheck}
        checked={isChecked('certificate', ['Delete'])}
        value="certificate:Delete"
        label="Excluir"
      />
    </PermissionGroup>
  )
}
